import "./Skills.css";
import { skills } from "../../skills";

function Skills() {
    return (
        <div className="skills-container">
            <div className="skills-header">Skills</div>

            <div className="skills-list">
                {
                    skills.map((skill, i) => {
                        return <div className="skill" key={i}>{skill}</div>
                    })
                }
            </div>
        </div>
    );
}

export default Skills;